export default function asciiSize({ length }) {
  return length
}
